import React from "react";

import "./ConfirmModal.css";

//Paramètres
//Title => Titre dans l'entête => String
//Message => Message dans le corp => String
//Cancel => Texte du bouton cancel => String
//onCancel => OnClick du bouton cancel => function
//Confirm => Texte du bouton cancel confirm => String
//onConfirm => OnClick du bouton confirm => function


const ConfirmModal = (props) => {

  if (!props.Display) return null;

  return (
    <div className="confirmmodal_page">
      <div className="confirmmodal_cont">
        <div className="confirmmodal_header">
          {props.Title}
        </div>
        <div className="confirmmodal_body">
          {props.Message}
        </div>
        <div className="confirmmodal_footer">
          <input
            type="button"
            className="page_button confirmmodal_button"
            value={props.Cancel}
            style={{backgroundColor: "grey"}}
            onClick={props.onCancel}
          />
          <input
            type="button"
            className="page_button confirmmodal_button"
            value={props.Confirm}
            onClick={props.onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
